import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/PartyContactDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class PartyContactEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyContact/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class PartyContactFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public partyId: IFieldOptions = { field: "partyId" };
	public typeId: IFieldOptions = { field: "typeId" };
	public value: IFieldOptions = { field: "value" };
	public isDefault: IFieldOptions = { field: "isDefault" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public status: IFieldOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.partyId);
		this.push(this.typeId);
		this.push(this.value);
		this.push(this.isDefault);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class PartyContactForm implements IFormOptions {
	protected partyContactFormName: string = "partyContactForm";
	protected partyContactFormModel: models.PartyContactDTO = new models.PartyContactDTO();
	protected partyContactFormEndPoints: PartyContactEndPoints = new PartyContactEndPoints();
	protected partyContactFormFields: PartyContactFormFields = new PartyContactFormFields();
	public get name(): string { return this.partyContactFormName };
	public get model(): models.PartyContactDTO { return this.partyContactFormModel };
	public get endPoints(): IEntityEndPoints { return this.partyContactFormEndPoints };
       public set endPoints(partyContactEndPoints: IEntityEndPoints) {
		this.partyContactFormEndPoints = partyContactEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): PartyContactFormFields { return this.partyContactFormFields };
}

export class PartyContactListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public partyId: IColumnOptions = { field: "partyId" };
	public typeId: IColumnOptions = { field: "typeId" };
	public value: IColumnOptions = { field: "value" };
	public isDefault: IColumnOptions = { field: "isDefault" };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public status: IColumnOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.partyId);
		this.push(this.typeId);
		this.push(this.value);
		this.push(this.isDefault);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class PartyContactList implements IGridOptions {
	protected partyContactListName: string = "partyContactList";
	protected partyContactListModel: models.PartyContactDTO = new models.PartyContactDTO();
	protected partyContactListEndPoints: PartyContactEndPoints = new PartyContactEndPoints();
	protected partyContactListColumns: PartyContactListColumns = new PartyContactListColumns();
	public partyContactForm: PartyContactForm = new PartyContactForm();
	public get name(): string { return this.partyContactListName };
	public get model(): models.PartyContactDTO { return this.partyContactListModel };
	public get endPoints(): IEntityEndPoints { return this.partyContactListEndPoints };
	public set endPoints(partyContactEndPoints: IEntityEndPoints) {
		this.partyContactListEndPoints = partyContactEndPoints;
		this.partyContactForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): PartyContactListColumns { return this.partyContactListColumns };
}

export class PartyContactEntity implements IEntityOptions {
	protected partyContactEntityName: string = "partyContactEntity";
	protected partyContactEntityModel: models.PartyContactDTO = new models.PartyContactDTO();
	protected partyContactEntityEndPoints: PartyContactEndPoints = new PartyContactEndPoints();
	protected partyContactEntityList: PartyContactList = new PartyContactList();
	public get name(): string { return this.partyContactEntityName };
	public get model(): models.PartyContactDTO { return this.partyContactEntityModel };
	public get endPoints(): IEntityEndPoints { return this.partyContactEntityEndPoints };
	public set endPoints(partyContactEndPoints: IEntityEndPoints) {
		this.partyContactEntityEndPoints = partyContactEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): PartyContactList { return this.partyContactEntityList };
	public get form(): PartyContactForm { return this.grid.partyContactForm };
	constructor(name?: string) {
		if (name) this.partyContactEntityName = name;
		this.endPoints = this.partyContactEntityEndPoints;
	}
};
//export class PartyContactGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: PartyContactForm = new PartyContactForm();
//};

//export class PartyContactListPageComponent extends ListPageComponent {
  //protected listPageComponentList: PartyContactList = new  PartyContactList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class PartyContactBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PartyContactGeneratedForm}];
//};

//export class PartyContactListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PartyContactListPageComponent, isMenuHidden: true }];
//};

